﻿import { action, makeObservable, observable } from "mobx";
import { TokenState } from "../models/TokenState";

const TOKEN_AGE_MARGIN_IN_SECONDS = 60;

export interface TokenInfo {
    token?: string | undefined;
    age: number;
}

export class TokenStore implements TokenState {

    private _timeoutId = 0;
    private tokenDateInSeconds: number | undefined = undefined;

    public token: string = '';
    public tokenAgeInSeconds: number | undefined = undefined;

    constructor(private getToken?: () => Promise<TokenInfo>) {
        makeObservable(this, {
            token: observable,
            setToken: action.bound
        })

        if (!this.getToken)
            console.error("Warning: no method defined to fetch chart token.");
    }

    /** @internal */
    public setToken(token: string, age?: number) {
        this.token = token;
        this.tokenAgeInSeconds = age;
        this.tokenDateInSeconds = Date.now() / 1000;
    }

    /**
     * Fetch chart token from server. By default an exising token is only replaced if it has expired.
     * @param ignoreExpiredToken 
     */
    public load = async (ignoreExpiredToken?: boolean) => {
        if (this.getToken && (ignoreExpiredToken || this.tokenExpired())) {
            clearTimeout(this._timeoutId);

            var tokenInfo: TokenInfo | undefined;

            try {
                tokenInfo = await this.getToken();
            }
            catch (e) {
                throw new Error(`Failed to retrieve chart token: Server returned an error`);
            }

            if (!tokenInfo || !tokenInfo.token)
                throw new Error(`Failed to retrieve chart token: Server returned no token`);

            this.setToken(tokenInfo.token, tokenInfo.age);

            this._timeoutId = window.setTimeout(this.load, (tokenInfo.age - TOKEN_AGE_MARGIN_IN_SECONDS) * 1000);
        }
    }

    private tokenExpired() {
        if (!this.token || !this.tokenAgeInSeconds || !this.tokenDateInSeconds) {
            return true;
        }
        else {
            return ((Date.now() / 1000) - this.tokenDateInSeconds) >= (this.tokenAgeInSeconds - (2 * TOKEN_AGE_MARGIN_IN_SECONDS));
        }
    }
}